import React from 'react'
import "../../styles/component/heading.scss"

const Heading = ({ className, text }) => {
    return (
        <h2 className={`main-heading ${className}`}>{text}</h2>
    )
}

export default Heading
